import { LanguageStrings } from "../types";
import { englishLocalizedStrings } from "../english";

export const englishUSLocalizedStrings: LanguageStrings = {
    ...englishLocalizedStrings,
    favorites: "Favorites",
    favorite: "Favorite",
    zip: "Zip",
};
